import { useEffect, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { getDonors } from 'src/shared/services/donorService';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { DonorResponse } from '../models/donor';

type DonorPickerProps = {
  label: string;
  initialValue?: number;
  callback: (donorId: number | undefined, donorName: string | undefined) => void;
};

export const DonorPicker = (props: DonorPickerProps) => {
  const { label, initialValue, callback } = props;
  const isMounted = useIsMounted();
  const [donors, setDonors] = useState<DonorResponse[]>([]);
  const [selectedDonor, setSelectedDonor] = useState<DonorResponse | null>(null);

  useEffect(() => {
    getDonors(0, 500, 'name', 'asc', '')
      .then((res) => {
        if (isMounted()) {
          const list = res.data.results ?? [];
          setDonors(list);
          if (initialValue) {
            const match = list.find((d) => d.id === initialValue);
            if (match) setSelectedDonor(match);
          }
        }
      })
      .catch((e) => ConsoleHelper.log(e));
  }, [isMounted, initialValue]);

  return (
    <Autocomplete
      size='small'
      options={donors}
      getOptionLabel={(option) => option.name || ''}
      value={selectedDonor}
      onChange={(_, val) => {
        setSelectedDonor(val);
        callback(val?.id, val?.name ?? undefined);
      }}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => <TextField {...params} label={label} InputLabelProps={{ shrink: true }} />}
      sx={{ minWidth: 220, backgroundColor: 'white' }}
    />
  );
};
